import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";
import { morph } from "@theme/morph";

const PRODUCT_INVENTORY = "product-inventory";

class ProductInventory extends Component {
  /**
   * Updates the inventory.
   * @param {import("@theme/events").VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = event => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newInventory = event.detail.data.html.querySelector(PRODUCT_INVENTORY);

    if (!newInventory) {
      return;
    }

    morph(this, newInventory, { childrenOnly: true });
  };

  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.addEventListener(
      ThemeEvents.variantUpdate,
      /** @type {EventListener} */ (/** @type {unknown} */ (this.updateInventory)),
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.removeEventListener(
      ThemeEvents.variantUpdate,
      /** @type {EventListener} */ (/** @type {unknown} */ (this.updateInventory)),
    );
  }
}

if (!customElements.get(PRODUCT_INVENTORY)) {
  customElements.define(PRODUCT_INVENTORY, ProductInventory);
}
